import React, { useCallback, useEffect, useState } from 'react';
import { getRecipeByMenuProduct } from '../services/menuProductPortionService';
import RecipeManager from './RecipeManager';

export default function MenuProductRecipeModal({ menuProduct, onClose }) {
  const [recipeItems, setRecipeItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refreshRecipe = useCallback(() => {
    setLoading(true);
    setError('');
    return getRecipeByMenuProduct(menuProduct.id)
      .then(items => setRecipeItems(Array.isArray(items) ? items : []))
      .catch(() => setError('No se pudo cargar la receta del producto.'))
      .finally(() => setLoading(false));
  }, [menuProduct.id]);

  useEffect(() => { refreshRecipe(); }, [refreshRecipe]);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 300,
        background: 'rgba(0,0,0,0.65)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 16,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        className="section-card"
        style={{ width: '100%', maxWidth: 640, marginBottom: 0, maxHeight: '90vh', overflowY: 'auto' }}
      >
        <div className="section-header">
          <h6>
            <i className="bi bi-egg-fried" style={{ color: 'var(--orig-green)' }} />
            Receta — {menuProduct.name}
          </h6>
          <button
            type="button"
            onClick={onClose}
            style={{ background: 'none', border: 'none', color: 'var(--orig-text-muted)', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}
            title="Cerrar"
          >
            ×
          </button>
        </div>

        <div className="section-body">
          {error && (
            <div className="alert-orig alert-error" style={{ marginBottom: 16 }}>
              <i className="bi bi-exclamation-triangle-fill" />
              {error}
            </div>
          )}

          {loading ? (
            <div style={{ padding: 24, textAlign: 'center', color: 'var(--orig-text-muted)' }}>
              <i className="bi bi-arrow-repeat" style={{ fontSize: 24, display: 'block', marginBottom: 8, animation: 'spin 1s linear infinite' }} />
              Cargando receta...
            </div>
          ) : (
            <RecipeManager
              menuProductId={menuProduct.id}
              recipeItems={recipeItems}
              onChange={refreshRecipe}
            />
          )}
        </div>

        <div style={{
          display: 'flex', justifyContent: 'flex-end', gap: 10,
          padding: '14px 20px', borderTop: '1px solid var(--orig-border)',
        }}>
          <button type="button" className="btn-orig btn-orig-outline" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}
